export enum AuthDetails{
    email = 'email', 
    password = 'password',
    tokenExpiryTime = 'tokenExpiryTime',
}